import { useCallback, useState } from "react";
import { TWebsiteBuilderToolbarMenuType } from "../../toolbar/menu/WebsiteBuilderToolbarMenu";

export interface IWebsiteBuilderToolbarState {
  menuType: TWebsiteBuilderToolbarMenuType;
  closingMenuPanel: boolean;
}

export type THandleSetToolbarMenuType = (menuType: TWebsiteBuilderToolbarMenuType) => void;

interface IUseWebsiteBuilderToolbarState {
  toolbarState: IWebsiteBuilderToolbarState;
  handleSetToolbarMenuType: THandleSetToolbarMenuType;
}

export function useWebsiteBuilderToolbarState(): IUseWebsiteBuilderToolbarState {
  const [toolbarState, setToolbarState] = useState<IWebsiteBuilderToolbarState>({
    menuType: "none",
    closingMenuPanel: false,
  });

  const handleSetToolbarMenuType = useCallback(
    (menuType: TWebsiteBuilderToolbarMenuType) => {
      if (!toolbarState.closingMenuPanel) {
        if (menuType !== "none") {
          setToolbarState(prev => ({
            ...prev,
            menuType,
          }));
        } else if (toolbarState.menuType !== "none") {
          setToolbarState(prev => ({
            ...prev,
            closingMenuPanel: true,
          }));

          setTimeout(() => {
            setToolbarState(prev => ({
              ...prev,
              menuType: "none",
              closingMenuPanel: false,
            }));
          }, 250);
        }
      }
    },
    [toolbarState.menuType, toolbarState.closingMenuPanel],
  );

  return {
    toolbarState,
    handleSetToolbarMenuType,
  };
}
